import styled from 'styled-components';
import { Button } from '../../../../components/styles/modal-style';

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const NotFoundContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const EditButtonContainer = styled(Button)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  height: auto;
`;

export const EditIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const ScriptsContainer = styled.div`
  margin-top: 2rem;
`;

export const ScriptsTitle = styled.h3`
  margin-bottom: 1rem;
  color: #696969;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const ScriptCard = styled.div`
  border: 1px solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const ScriptName = styled.div`
  margin-bottom: 0.5rem;
`;

export const ScriptNameLabel = styled.span`
  font-weight: 600;
  color: #696969;
`;

export const AdditionalDeadline = styled.span`
  color: #007bff;
  margin-left: 8px;
`;

export const ScriptSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
`;

export const ItemCard = styled.div`
  border: 1px solid #EBEBEB;
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  margin-right: 1rem;
`;

export const StepNumber = styled.div`
  margin-bottom: 0.5rem;
`;

export const StepLabel = styled.span`
  font-weight: 600;
  color: #696969;
  font-size: 0.9rem;
`;

export const NoItemsMessage = styled.div`
  text-align: center;
  padding: 0.5rem;
  color: #696969;
  font-size: 0.9rem;
`;
